"use client";

import * as C from "@/components";
import { useCallback, useState } from "react";
import { PlayButton } from "../icons/PlayButton";
import VadImage from "vadimages-nextjs-image-optimizer";
import ModalVideo from "vadimages-react-modal-video";

const imageDirectory = "/images/singular/video-thumbnails/";

interface VimeoCardPlayerProps {
  cardTitle: string;
  vimeoId: number;
  thumbnailName: string;
  mobileVimeoId: number;
}

const VimeoCardPlayer = ({
  cardTitle,
  vimeoId,
  thumbnailName,
  mobileVimeoId,
}: VimeoCardPlayerProps) => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [isMobileModalOpen, setIsMobileModalOpen] = useState<boolean>(false);

  const toggleModal = useCallback(() => {
    if (window) {
      if (window.innerWidth >= 768) {
        setIsModalOpen(true);
      } else {
        setIsMobileModalOpen(true);
      }
    }
  }, []);

  return (
    <>
      <C.Card
        className="relative w-fit p-4"
        onClick={toggleModal}
      >
        <div className="relative rounded-default overflow-hidden w-[282px]">
          <VadImage
            src={`${imageDirectory}${thumbnailName}`}
            alt={cardTitle}
            width={282}
            height={159}
          />
        </div>
        <p className="mt-6 max-w-[300px]">{cardTitle}</p>
      </C.Card>

      <div className="hidden md:block">
        <ModalVideo
          channel="vimeo"
          videoId={`${vimeoId}`}
          isOpen={isModalOpen}
          onClose={() => {
            setIsModalOpen(false);
          }}
          ratio="16:9"
        />
      </div>
      <div className="block md:hidden">
        <ModalVideo
          channel="vimeo"
          videoId={`${mobileVimeoId}`}
          isOpen={isMobileModalOpen}
          onClose={() => {
            setIsMobileModalOpen(false);
          }}
          ratio="9:16"
        />
      </div>
    </>
  );
};

export default VimeoCardPlayer;
